import { ClerkProvider } from '@clerk/clerk-react';

const clerkPubKey = import.meta.env.CLERK_PUBLISHABLE_KEY;

if (!clerkPubKey) {
  throw new Error('Missing Clerk publishable key');
}

export { ClerkProvider };
export const CLERK_PUBLISHABLE_KEY = clerkPubKey;
